import { Link } from 'react-router';
import { createTrackingValue } from '@/lib/stringUtils';
import { cn } from '@/lib/utils';
import type { HeaderNavStrings } from './headerStrings';

const LINK_CLASSES = [
    'flex items-center rounded-full px-2 py-0.5 whitespace-nowrap transition-colors lg:py-1',
    'font-bold text-[16px] leading-6 lg:text-[18px]',
    'light:text-gz-marine-800 dark:text-gz-neutral-100',
    'light:hover:bg-gz-tan-350 dark:hover:bg-gz-blue-600',
    'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-secondary-accent/50',
    'light:focus-visible:ring-gz-marine-700/50 dark:focus-visible:ring-gz-marine-500/50',
].join(' ');

export interface HeaderNavLinksProps {
    /** `Explore` is behind auth, so it only renders for a signed-in user. `Library` is public. */
    isSignedIn: boolean;
    /** Translated by the caller (see headerStrings.ts). */
    strings: HeaderNavStrings;
    className?: string;
}

export const HeaderNavLinks = ({ isSignedIn, strings, className }: HeaderNavLinksProps) => {
    return (
        <nav
            aria-label={strings.label}
            className={cn('flex min-w-0 flex-1 items-center justify-center gap-6 py-1 lg:justify-start lg:gap-8', className)}
        >
            {isSignedIn && (
                <Link
                    to="/explore"
                    className={LINK_CLASSES}
                    data-track-click="Header Nav Link Clicked"
                    data-track-location="header"
                    data-track-button-name={createTrackingValue('nav', 'explore')}
                >
                    {strings.explore}
                </Link>
            )}
            <Link
                to="/library"
                className={LINK_CLASSES}
                data-track-click="Header Nav Link Clicked"
                data-track-location="header"
                data-track-button-name={createTrackingValue('nav', 'library')}
            >
                {strings.library}
            </Link>
        </nav>
    );
};
